export const vehicleStateEnum = Object.freeze({
    FOR_SALE: '2',
    SOLD_PENDING_PAYMENT: '3',
    SOLD_PENDING_DOCUMENTATION: '4',
    STAND_BY: '5',
    PENDING_RETURN_ACCEPTANCE: '6',
    PENDING_ASSIGN_BUYER: '7',
    SOLD_AND_TRANSFERRED: '8',
    REMARKETING_DEREGISTERED: '9',
    RETURN_REJECTED: '10',
    BLOCKED_FOR_SALE: '11',
    LEGAL_DISPUTE_DACION: '12',
    DIRECT_ENTRY_LOGISTICS: '13',
    DIRECT_ENTRY_AGENCY: '14',
    DECISION_CHANGE_NO_RETURN: '15'
});
